module.exports = __webpack_public_path__ + "static/media/04-benefit-private-lounge.02ba7078.jpg";